(function () {
  // Bail early if carousel tabs are not present
  if (!document.querySelector('.product-carousel-tabs')) return;

  function triggerRecalc() {
    // Force layout flush
    void document.body.offsetHeight;

    // Mimic the scroll/resize that fixes TF rendering
    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('scroll'));

    // Re-run TestFreaks items rendering
    window.testFreaks = window.testFreaks || [];
    window.testFreaks.push(['load', 'items']);
  }

  function afterVisibleWork() {
    // Wait for:
    // 1) tab class toggle
    // 2) Swiper observer width recalculation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(triggerRecalc, 0);
        setTimeout(triggerRecalc, 150);
      });
    });
  }

  // 1) Tab title clicks
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.product-carousel-tabs .tab__title')) return;
    afterVisibleWork();
  });

  // 2) Tab panel becomes active (non-click activation)
  const observer = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      if (m.type !== 'attributes' || m.attributeName !== 'class') continue;
      const el = m.target;
      if (
        el instanceof HTMLElement &&
        el.matches('.product-carousel-tabs .tab__content') &&
        el.classList.contains('active')
      ) {
        afterVisibleWork();
      }
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
